import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CmsService, OccEndpointsService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';

@Component({
    selector: 'app-immunization-schedules-banner',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './immunization-schedules-banner.component.html',
    standalone: false
})
export class ImmunizationSchedulesBannerComponent implements OnInit, OnDestroy {
  private slotCompUid1: string =
    'ImmunizationSchedulesSquareBannerPDFComponent1';
  private slotCompUid2: string =
    'ImmunizationSchedulesSquareBannerPDFComponent2';
  imgUrl1: string = '';
  imgUrl2: string = '';
  private baseUrl: string = '';
  cmsSub: Subscription;
  cmsSub2: Subscription;

  constructor(
    private readonly cmsData: CmsService,
    private readonly occEndPoint: OccEndpointsService,
    private _dataService: DataLayerService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit(): void {
    //uid of the comp
    this.cmsSub = this.cmsData
      .getComponentData(this.slotCompUid1)
      .subscribe((res: any) => {
        if (res) {
          this.imgUrl1 = this.baseUrl + res?.document.url;
          let cmsResp = JSON.parse(JSON.stringify(res));
          cmsResp.media = cmsResp?.document;
          if (cmsResp?.media?.url) {
            this._dataService.addtoDataLayer('view_promotion', cmsResp);
          }
        }
      });

    this.cmsSub2 = this.cmsData
      .getComponentData(this.slotCompUid2)
      .subscribe((res: any) => {
        if (res) {
          this.imgUrl2 = this.baseUrl + res?.document.url;
          let cmsResp = JSON.parse(JSON.stringify(res));
          cmsResp.media = cmsResp?.document;
          if (cmsResp?.media?.url) {
            this._dataService.addtoDataLayer('view_promotion', cmsResp);
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.cmsSub?.unsubscribe();
    this.cmsSub2?.unsubscribe();
  }
}
